import { Cell, Pie, PieChart, ResponsiveContainer } from 'recharts';
import { HoursRangeFront } from '../../../channel-details/optimizer/configuration/types';
import { calculateSegmentsByPricingTier, formatHour, heatmapColors } from '../utils';

const COLORS = {
  1: heatmapColors[0],
  2: heatmapColors[3],
  3: heatmapColors[6],
};

type TariffPieProps = {
  ranges?: HoursRangeFront[];
};

const RADIAN = Math.PI / 180;

const CustomPieLabel = ({ cx, cy, startAngle, outerRadius, start }) => {
  const radius = outerRadius + 10;
  const x = cx + radius * Math.cos(-startAngle * RADIAN);
  const y = cy + radius * Math.sin(-startAngle * RADIAN);

  return (
    <text x={x} y={y} fill="var(--color-type-primary)" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
      {formatHour(start)}
    </text>
  );
};

export const ChartPie: React.FC<TariffPieProps> = ({ ranges = [] }) => {
  const data = calculateSegmentsByPricingTier(ranges);

  return (
    <ResponsiveContainer width="100%" height={300}>
      <PieChart>
        <Pie
          data={data}
          dataKey="value"
          nameKey="pricingTier"
          cx="50%"
          cy="50%"
          innerRadius={70}
          outerRadius={90}
          startAngle={115}
          endAngle={-270}
          paddingAngle={3}
          animationDuration={500}
          label={CustomPieLabel}
          labelLine={false}
        >
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[entry.pricingTier] || COLORS[2]} />
          ))}
        </Pie>
      </PieChart>
    </ResponsiveContainer>
  );
};
